import { useToastStore } from 'components/ToastManager/useToasts';

export const pushAlert = (message, type) => (dispatch) => {
    // dispatch({
    //   type: PUSH_ALERT,
    //   payload: { message: message, type: type }
    // });
    // setTimeout(() => dispatch({ type: REMOVE_ALERT }), 3000);

    const resolveType = (type) => {
        switch (type) {
            case 'danger':
                return 'error';
            default:
                return type;
        }
    };

    useToastStore.getState().addToast({
        description: message,
        type: resolveType(type)
    });
};
